export default __webpack_public_path__ + "static/media/fire.e231e7b3.svg";